<template>
  <img
    src="@/assets/images/gifs/clap.gif"
    alt="clap"
  >
</template>
<script setup lang="ts">
</script>